import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { AppState } from '@store/types'
import type React from 'react'
import { useSelector } from 'react-redux'

import { selectIsLoading } from '@/store'
import type { StorageState } from '@/types'
import {
  DeletedFile,
  DocumentThumbnail,
  ImageThumbnail,
  LoadingFile,
} from './components'
import { isImageFile } from './helper'

interface Props {
  id: ID
  selected: boolean
}

export const FileContent: React.FC<Props> = ({ id, selected }) => {
  const loading = useSelector(selectIsLoading(id, 'storage'))
  const storage = useSelector<AppState, StorageState>(
    migrationProjectSelector.getProjectStorage
  )

  const data = storage.items.find((item) => item.id === id)

  if (loading) {
    return <LoadingFile selected={selected} />
  }

  if (!data) {
    return <DeletedFile selected={selected} />
  }

  if (isImageFile(data.filename)) {
    return <ImageThumbnail selected={selected} file={data} />
  }

  return <DocumentThumbnail selected={selected} data={data} />
}
